import jMoment from 'moment-jalaali';
import { TableItemActionsNew, Icons } from 'components';
export const GRANTED_OPERATION_CODE = {
  FINANCIAL_OPERATION_INVOICE: 'فاکتور',
  FINANCIAL_OPERATION_TRANSFER: 'انتقال وجه',
  FINANCIAL_OPERATION_REQUEST_SETTLEMENT: 'تسویه حساب',
  FINANCIAL_OPERATION_GET_CREDIT: 'موجودی حساب',
  FINANCIAL_OPERATION_ACCOUNT_BILL: 'صورتحساب',
};

const status = {
  FINANCIAL_PERMISSION_STATUS_REQUESTED: 'درخواست شده',
  FINANCIAL_PERMISSION_STATUS_CONFIRMED: 'تایید شده',
  FINANCIAL_PERMISSION_STATUS_REVOKED: 'لغو شده',
  FINANCIAL_PERMISSION_STATUS_REJECTED: 'رد شده',
  FINANCIAL_PERMISSION_STATUS_DELETED: 'حذف شده',
};

const columns = (actionsList, actionLoading, onActionClick) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه درخواست',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'تاریخ درخواست',
    field: 'grantDate',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rc) => jMoment(rc?.grantDate).format('dddd, jD jMMMM jYYYY'),
  },
  {
    title: 'مجوز گیرنده',
    field: 'grantedUserId',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) =>
      rd?.grantedUser?.name ? `${rd?.grantedUser?.name} (${rd?.grantedUser?.id})` : '',
  },
  {
    title: 'نوع مجوز',
    field: 'grantedOperationCode',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => GRANTED_OPERATION_CODE[rd?.grantedOperationCode],
  },
  {
    title: 'نوع حساب',
    field: 'guildCode',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rc) => (rc?.guildSrv?.name ? rc?.guildSrv?.name : rc?.walletSrv?.name),
  },
  {
    title: 'وضعیت',
    field: 'grantStatus',
    align: 'center',
    filtering: false,
    sorting: false,
    cellStyle: {
      width: '10%',
    },
    headerStyle: {
      width: '10%',
    },
    render: (rd) => (rd?.grantStatus ? `${status[rd?.grantStatus]}` : '-'),
  },

  ...((actionsList['permissionsReceiveUpdateGuildBtn'] ||
    actionsList['permissionsReceiveDeleteGuildBtn'] || actionsList['permissionsReceiveCancelGuildBtn']) ? [{
      title: 'عملیات',
      field: 'operationSmall',
      filtering: false,
      sorting: false,
      align: 'right',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rowData) => (
        <TableItemActionsNew
          iconButton
          startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
          title=""
          otherMenus={[
            {
              title: 'تایید درخواست',
              isShow: !!actionsList['permissionsReceiveUpdateGuildBtn'],
              loading: actionLoading,
              onClick: () => {
                onActionClick(rowData, 'accept');
              },
              disabled: rowData.grantStatus === 'FINANCIAL_PERMISSION_STATUS_CONFIRMED',
            },
            {
              title: 'حذف مجوز',
              isShow: !!actionsList['permissionsReceiveDeleteGuildBtn'],
              loading: actionLoading,
              onClick: () => {
                onActionClick(rowData, 'delete');
              },
            },
            {
              title: 'لغو مجوز',
              isShow: !!actionsList['permissionsReceiveCancelGuildBtn'],
              loading: false,
              disabled: rowData.grantStatus === 'FINANCIAL_PERMISSION_STATUS_REVOKED',
              onClick: () => {
                onActionClick(rowData, 'cancel');
              },
            },
          ]}
        />
      ),
    }] : []),
];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, generateData };
